export default ({}) => {
  const state = {};

  const mutations = {};

  const actions = {};

  return { state, mutations, actions };
};
